import React from "react";
import { Trans } from "@lingui/macro";
import { connectStateResults } from "react-instantsearch-dom";
import { StateResultsProvided } from "react-instantsearch-core";
import { Button } from "@silversea-ssc/ui-components-react";
import { extractAppliedFilters } from "src/utils/algoliaFiltersHelper";

interface SetFiltersButtonProps extends Partial<StateResultsProvided> {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string;
  appliedFiltersButtonLabel?: string | JSX.Element;
  filtersButtonLabel?: string | JSX.Element;
}

const SetFiltersButtonBase: React.FC<SetFiltersButtonProps> = ({
  onClick,
  className,
  searchState = {},
  appliedFiltersButtonLabel = <Trans>Edit your filters</Trans>,
  filtersButtonLabel = <Trans>Filter the results</Trans>
}) => {
  const appliedFilters = extractAppliedFilters(searchState);
  const appliedFiltersCount = appliedFilters.counter;

  return (
    <Button
      renderAs="button"
      variant="primary"
      full
      onClick={onClick}
      className={className}
      iconName="chevron-right"
    >
      {appliedFiltersCount > 0 ? (
        <span>{appliedFiltersButtonLabel}</span>
      ) : (
        <span>{filtersButtonLabel}</span>
      )}
    </Button>
  );
};

export default connectStateResults<SetFiltersButtonProps>(SetFiltersButtonBase);
